module.exports = __webpack_public_path__ + "img/product-showcase-gallery-01.ac78f581.jpg";